module.exports = __webpack_public_path__ + "media/clair-de-lune.5f491cfd.mp3";